import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable({ providedIn: 'root' })
export class ImpactTrackerAnalytics extends AnalyticsBase {
  public readonly namespace = 'ImpactTracker';
  public readonly requireViewContext = false;

  public trackDialogTriggered(context: 'banner' | 'dropdown'): void {
    this.track('DialogTriggered', { context });
  }

  public trackBannerDisplayed(): void {
    this.track('BannerDisplayed');
  }

  public trackBannerDismissed(): void {
    this.track('Dismissed');
  }
}
